$shm_hitalama_map_editor $mol_book2
	map $shm_hitalama_map
	widget $shm_hitalama_map_widget
	Widget* $shm_hitalama_map_widget_any
	auto /
		<= autobackup? null
	selected_links? /
	go_to_frame_by_num* null
	set_frame* null
	widgets_filtered /$shm_hitalama_map_widget
	placeholders /
	pages /
		^ edit_page / <= Edit_page $mol_page
			head /
				<= Title $mol_string_button
					value? <=> title?
				<= Settings $mol_pick
					hint \Click to show settings
					trigger_content /
						<= Settings_trigger_icon $mol_icon_dots_vertical
					bubble_content /
						<= Settings_content $mol_list
							sub /
								- <= Description_field $mol_form_field
									name \Описание
									Content <= Description_edit $mol_textarea
										value? <=> description? \
								<= Hide_head_tools $mol_check_box
									title \Скрыть настройки
									checked? <=> hide_head_tools? false
								<= Description_field $mol_form_field
									name \Описание
									Content <= Description_edit $mol_textarea
										value? <=> description? \
								<= Tags_field $mol_form_field
									name \Теги
									Content <= Tags_edit $shm_hitalama_select_list
										value? <=> tags? /string
										options? <=> used_tags? /string
								<= Cut_pick $mol_pick
									align \center
									showed? <=> cut_bubble_showed? false
									trigger_content /
										<= Cut_icon $mol_icon_trash_can
										\Удалить
									bubble_content /
										<= Cut_bubble $mol_view
											sub /
												<= Cut_text $mol_text
													text \Удалить?
												<= Cut_yes $mol_button_minor
													title \Да
													click? <=> widget_cut? null
												<= Cut_no $mol_button_minor
													title \Нет
													click? <=> cut_cancel? null
				<= Settings_free_space $mol_view
				<= Code_panel $shm_hitalama_map_widget_float_code_panel
					no_crdt <= code_no_crdt false
					code_download_blob <= code_download_blob null
					code_download_file_name <= code_download_file_name \
					template_dictionary <= template_dictionary *
					template_selected? <=> template_selected? \
					enabled? <=> code_enabled? true
					run_click? <=> run_click? null
			body /
				<= Widget_content $mol_scroll
					sub /
						<= Widget_code_content $mol_view
							sub <= widget_code_content /
		^ preview_page / <= Preview_page $shm_hitalama_page
			resize_side \left
			width_max 2000
			head /
				^ preview_head /
					<= Pin $mol_button_minor
						sub /
							<= Pin_icon $mol_icon_pin
							\Закрепить
						click? <=> preview_pin? null
					<= Unpin $mol_button_minor
						sub /
							<= Unpin_icon $mol_icon_pin_off
							<= preview_widget
						click? <=> preview_unpin? null
					<= Preview_reload $mol_button_minor
						hint \Обновить
						sub /
							<= Preview_reload_icon $mol_icon_refresh
						click? <=> preview_reload? null
					<= Preview_fullscreen $mol_view
			body /
				<= Preview_content $mol_view
